import SliderSlick from 'react-slick';
import styled from 'styled-components';
import { whiteTheme } from 'styles/themes/whiteTheme';

export const SliderUI = styled(SliderSlick)`
  max-width: 212px;
  width: 100%;
  margin: 0 auto;
  .slick-slide {
    padding-left: 20px;
    padding-right: 20px;
    @media screen and (max-width: 1300px) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .PrevArrow,
  .NextArrow {
    top: 20%;
    padding: 12px;
  }
  .PrevArrow {
    left: -15px;
  }
  .NextArrow {
    right: -15px;
  }
  ${whiteTheme.media.laptopS} {
    max-width: 400px;
  }
  ${whiteTheme.media.tabletL} {
    max-width: 212px;
  }
  ${whiteTheme.media.tablet} {
    max-width: 780px;
  }
  ${whiteTheme.media.mobileL} {
    max-width: 300px;
  }
`;

export const RelatedCompaniesAndBrandsWrap = styled.div`
  margin-bottom: 40px;
  ${whiteTheme.media.tabletL} {
    display: none;
  }
`;
